module.exports = new __parcel__URL__("megaphone-opsgenie-xflow.f7301baa.svg").toString();